import React, {useEffect, useState} from 'react';
import {Circle, GoogleMap, Marker, withGoogleMap} from 'react-google-maps';
import {
    getOnlyTotalLocationRequest,
    getTotalLocationRequest
} from "../../../../../../api/hrm/timekeeping/time-sheet/location";
import {API_KEY_MAP_GG, DEFAULT_RADIUS, MAPS_JAVASCRIPT_API, TOTAL_LIMIT} from "../../constant/key";
import {t} from "i18next";
const MapComponent = withGoogleMap(props => {
    const [mapRef, setMapRef] = useState(null);

    useEffect(() => {
        if (mapRef) {
            mapRef.panTo({lat: props.marker.lat, lng: props.marker.lng});
        }
    }, [props.marker]);


    return (

           <GoogleMap
            ref={(map) => setMapRef(map)}
            defaultCenter={{lat: props.marker.lat, lng: props.marker.lng}}
            defaultZoom={15}
            onClick={props.onMapClick}
            defaultMapTypeId={"roadmap" || "satellite"}
            onTilesLoaded={() => {
                getTotalLocationRequest(MAPS_JAVASCRIPT_API, API_KEY_MAP_GG).then(res => { // update
                    props.setTotalLimit(res)
                })
            }}
        >
            <Marker
                position={{lat: props.marker.lat, lng: props.marker.lng}}
                title={props.marker.title}
            />
            <Circle
                center={{lat: props.marker.lat, lng: props.marker.lng}}
                radius={props.radius}
                options={{
                    strokeColor: '#4285F4',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#4285F4',
                    fillOpacity: 0.35,
                }}
            />


        </GoogleMap>
    )
});

const GoogleMapsContainer = ({radius, coordinates,setRadius}) => {
    const initialMarker = {
        lat: coordinates[0] || 21.028511,
        lng: coordinates[1] || 105.804817,
    };
    const [marker, setMarker] = useState(initialMarker);
    const [totalLimit, setTotalLimit] = useState(0);

    useEffect(() => {
        getOnlyTotalLocationRequest(MAPS_JAVASCRIPT_API, API_KEY_MAP_GG).then(r => { // get
            setTotalLimit(r)
        })
    },[])

    const handleMapClick = event => {
        const newMarker = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        };
        setMarker(newMarker);
    };

    useEffect(() => {
        setMarker({
            lat:  coordinates[0] || marker.lat,
            lng:  coordinates[1] || marker.lng,
        })
        if(radius === 0 || radius === undefined || radius === null){
            setRadius(DEFAULT_RADIUS)
        }

    }, [coordinates]);
    return (
      totalLimit <= TOTAL_LIMIT ?  <div style={{height: '300px'}}>
            <MapComponent
                containerElement={<div style={{height: '100%'}}/>}
                mapElement={<div style={{height: '100%'}}/>}
                marker={marker}
                radius={radius}
                onMapClick={handleMapClick}
                setTotalLimit={(value) => setTotalLimit(value)}
            />
      </div> : <div style={{height: '100px'}}>{t("tnp.setting.limitRequest")}</div>
    );
};

export default GoogleMapsContainer;
